"use client";
import { useDotButton } from "@/lib/useDotButton";
import { Card } from "@mui/material";
import { EmblaCarouselType } from "embla-carousel";

export default function CarouselFooter({ emblaApi }: { emblaApi?: EmblaCarouselType | undefined }) {
  const { onDotButtonClick, scrollSnaps, selectedIndex } = useDotButton(emblaApi);
  return (
    <>
      {scrollSnaps.map((_, index) => (
        <Card
          elevation={0}
          key={index}
          onClick={() => onDotButtonClick(index)}
          sx={{
            cursor: "pointer",
            transition: "0.2s all",
            width: selectedIndex === index ? 6 * 3 : 6,
            height: 6,
            borderRadius: 50,
            backgroundColor: selectedIndex === index ? "secondary.main" : "grey.50",
          }}
        />
      ))}
    </>
  );
}
